export enum SecuritySettingType {
  PasswordChange = 1,
  PasskeyManager = 2,
}
